// 气象路由
import weatherLayout from '@/layout/index.vue'
import weatherHome from '@/views/weather/home.vue'
import weatherSearch from '@/views/weather/search.vue'
import weatherList from '@/views/weather/list.vue'
import weatherCompare from '@/views/weather/compare.vue'
import weatherStation from '@/views/weather/station.vue'
import weatherCollector from '@/views/weather/collector.vue'

const router = {
  path: '/layout',
  name: 'weatherLayout',
  component: weatherLayout,
  redirect: '/home',
  children: [
    // 概览
    {
      path: '/weather/home',
      name: 'weather_home',
      meta: {
        showTab: true,
        name: 'weather_home mulshow',
        title: '气象 概览'
      },
      component: weatherHome
    },
    // 气象查询
    {
      path: '/weather/search',
      name: 'weather_search',
      meta: {
        showTab: true,
        name: 'weather_search mulshow',
        title: '气象 查询'
      },
      component: weatherSearch
    },
    // 气象列表
    {
      path: '/weather/list',
      name: 'weather_list',
      meta: {
        showTab: true,
        name: 'weather_list mulshow',
        title: '气象 列表'
      },
      component: weatherList
    },
    // 气象对比
    {
      path: '/weather/compare',
      name: 'weather_compare',
      meta: {
        showTab: true,
        name: 'weather_compare mulshow',
        title: '气象对比'
      },
      component: weatherCompare
    },
    // 气象电站设置
    {
      path: '/weather/station',
      name: 'weather_station',
      meta: {
        showTab: true,
        name: 'weather_station mulshow',
        title: '电站设置'
      },
      component: weatherStation
    },
    // 气象采集器列表
    {
      path: '/weather/collector',
      name: 'weather_collector',
      meta: {
        showTab: true,
        name: 'weather_collector mulshow',
        title: '采集器列表'
      },
      component: weatherCollector
    }
  ]
}

export default router
